import { reactive } from "vue";

/**
 * Service for managing booking conflict resolution
 * Encapsulates conflict state and resolution logic
 */
export class ConflictService {
	constructor() {
		this.state = reactive({
			hasConflict: false,
			conflictingDates: [],
			closedDates: [],
			hasBookingConflicts: false,
			hasClosedHours: false,
			originalData: {},
			endpoint: "",
			originalMode: "",
		});
	}

	setConflict(conflictError) {
		this.state.hasConflict = true;
		this.state.conflictingDates = conflictError.conflictingDates || [];
		this.state.closedDates = conflictError.closedDates || [];
		this.state.hasBookingConflicts = conflictError.hasBookingConflicts || false;
		this.state.hasClosedHours = conflictError.hasClosedHours || false;
		this.state.originalData = conflictError.originalData || {};
		this.state.endpoint = conflictError.endpoint || "";
		this.state.originalMode = conflictError.originalMode || "";
	}

	clearConflict() {
		this.state.hasConflict = false;
		this.state.conflictingDates = [];
		this.state.closedDates = [];
		this.state.hasBookingConflicts = false;
		this.state.hasClosedHours = false;
		this.state.originalData = {};
		this.state.endpoint = "";
		this.state.originalMode = "";
	}

	getConflictData() {
		return {
			hasConflict: this.state.hasConflict,
			conflictingDates: [...this.state.conflictingDates],
			closedDates: [...this.state.closedDates],
			hasBookingConflicts: this.state.hasBookingConflicts,
			hasClosedHours: this.state.hasClosedHours,
		};
	}

	getOriginalData() {
		return { ...this.state.originalData };
	}
	
	getOriginalMode() {
		return this.state.originalMode;
	}

	getEndpoint() {
		return this.state.endpoint;
	}

	hasActiveConflict() {
		return this.state.hasConflict;
	}

	createResolutionData(updatedData) {
		return {
			data: updatedData,
			endpoint: this.state.endpoint,
		};
	}
}

/**
 * Composable for using conflict service in components
 */
export function useConflictService() {
	const conflictService = new ConflictService();

	return {
		conflictState: conflictService.state,
		setConflict: (error) => conflictService.setConflict(error),
		clearConflict: () => conflictService.clearConflict(),
		getConflictData: () => conflictService.getConflictData(),
		getOriginalData: () => conflictService.getOriginalData(),
		getOriginalMode: () => conflictService.getOriginalMode(),
		createResolutionData: (data) => conflictService.createResolutionData(data),
		hasActiveConflict: () => conflictService.hasActiveConflict(),
	};
}